let _get = null;
let _post = null;

export default function MiniBeanBiddingApi($get, $post) {
  _get = $get;
  _post = $post;
  return miniBeanBiddingApi;
}

function getMiddleware(url, params, type = 'act') {
  if (_get) {
    return _get('/creator/', {
      [type]: url,
      ...params,
    });
  } else {
    return console.warn('function _get is undefined!');
  }
}

function postMiddleware(url, params, type = 'act') {
  if (_post) {
    return _post(`/creator/?${type}=${url}`, {
      ...params,
    });
  } else {
    return console.warn('function _post is undefined!');
  }
}

export const miniBeanBiddingApi = {
  getMaps: params => getMiddleware('promo_plan_query_map_list', params),
  getPlans: params => getMiddleware('promo_plan_query_list', params),
  switchPlan: params => getMiddleware('promo_plan_switch', params),
  switchPlanMap: params => getMiddleware('promo_plan_map_switch', params),
  addPlan: params => postMiddleware('promo_plan_add', params),
  deletePlan: params => getMiddleware('promo_plan_del', params),
  updatePlan: params => postMiddleware('promo_plan_modify', params),
  getPlanInfo: params => getMiddleware('promo_plan_query', params),
  planPowerCheck: params => getMiddleware('promo_plan_power_check', params),
  isJoinStarPlan: async () => {
    const currTime = new Date();
    const currMonth = currTime.getMonth() + 1;
    const params = {
      page: 1,
      page_size: 30,
      month:
        currTime.getFullYear() +
        '' +
        (currMonth < 10 ? '0' + currMonth : currMonth),
    };
    const res = await getMiddleware('get_xq_maps', params);
    if (res.code == 218) {
      return false;
    } else {
      return true;
    }
  },
  getScoreOverview: params => getMiddleware('get_score_overview', params),
};
